export default "__VITE_ASSET__CgDnoSDK__"